var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"relative w-full"},[_c('Carousel'),_c('ProductList',{attrs:{"title":"推薦商品"}}),_c('About'),_c('NewsList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }